import { v4 } from 'uuid';

export const createEntity = (attributes: Record<string, unknown>) => ({
  ...attributes,
  id: v4(),
});
